;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$timeout", "$element", "$window"];
  angular.module('app.survey').component('surveySlider', {
    bindings: {
      values: '=',
      labelKey: '@',
      selectedSrc: '<selected',
      onChange: '&',
      hidePin: '<',
      extremitiesOnly: '=',
      leftExtremityLabel: '@',
      rightExtremityLabel: '@',
      wrapLabels: '<',
      dragHint: '=',
      dragHintLabel: '<',
      snap: '@',
    },
    templateUrl: 'survey-slider.template.html',
    controller: Controller,
  })

  /* @ngInject */
  function Controller($scope, $timeout, $element, $window) {
    var ctrl = this

    var win = angular.element($window)
    var slider = angular.element($element[0].querySelector('.survey-slider'))
    var bar = angular.element($element[0].querySelector('.survey-slider__bar'))
    var pin = angular.element($element[0].querySelector('.survey-slider__pin'))
    var pinLabel = angular.element(
      $element[0].querySelector('.survey-slider__pin-label')
    )

    ctrl.$onInit = onInit
    ctrl.$onChanges = onChanges
    ctrl.getSegmentLabel = getSegmentLabel

    function onInit() {
      ctrl.showDragHint = ctrl.dragHint !== false
      ctrl.onlyShowExtremities = ctrl.extremitiesOnly === true
      // timeout allows siblings to mount first
      // ctrl.visible prevents 1ms ui flashing
      $timeout(function() {
        layout()
        select(ctrl.selectedSrc, true, undefined, true)
        ctrl.visible = true
      })

      // set up events
      slider.on('touchstart mousedown', onTouchStart)
      angular.element($window).on('resize', onLayoutChange)
      $scope.$on('slider:layout-changed', onLayoutChange)
      $scope.$on('destroy', onDestroy)
    }

    function onChanges(changes) {
      if (
        changes.hidePin &&
        changes.hidePin.currentValue !== changes.hidePin.previousValue
      ) {
        if (ctrl.hidePin) {
          select(null, undefined, false, true)
          pin.css({ left: '50%' })
          pin.addClass('-hidden')
          pinLabel.addClass('-hidden')
        } else {
          // select(null, undefined, false, true);
          // pinLabel.removeClass('-hidden');
          pin.removeClass('-hidden')
        }
      }
      if (
        changes.selectedSrc &&
        !changes.selectedSrc.isFirstChange() &&
        changes.selectedSrc.currentValue !== changes.selectedSrc.previousValue
      ) {
        if ((ctrl.selected && ctrl.selected.value) === ctrl.selectedSrc) return
        select(ctrl.selectedSrc, true, undefined, true)
      }
    }

    function onLayoutChange() {
      layout()
      select(ctrl.selected && ctrl.selected.value, true, undefined, true)
    }

    // TODO: debounce/throttle this call
    function layout() {
      // calculate min/max positions
      var barRect = bar[0].getBoundingClientRect()
      ctrl.minLeft = barRect.left
      ctrl.maxLeft = barRect.right
      ctrl.width = ctrl.maxLeft - ctrl.minLeft

      // decide if we are only showing edge labels
      ctrl.edgeOnly =
        ctrl.onlyShowExtremities === true ||
        win[0].document.body.offsetWidth < 600

      // calculate segments and segment sizes
      ctrl.segments = []
      var segmentWidth = ctrl.width / (ctrl.values.length - 1)
      _.each(ctrl.values, function(value, i) {
        ctrl.segments.push({
          position: i * segmentWidth + ctrl.minLeft,
          value: value,
          width: getSegmentWidth(i === 0 || i === ctrl.values.length - 1),
          label: getLabel(value),
        })
      })

      $scope.$applyAsync()
    }

    function select(value, snap, animated, silent) {
      var segment = _.find(ctrl.segments, { value: value })

      if (animated) {
        pin.addClass('-animate-left')
        pinLabel.addClass('-animate-left')
      } else {
        pin.removeClass('-animate-left')
        pinLabel.removeClass('-animate-left')
      }

      if (!segment) {
        if (!ctrl.selected) {
          pin.css({ left: '50%' })
        }
        pin.removeClass('-moving -active')
        pin.addClass('-inactive')
        pinLabel.addClass('-hidden')

        // otherwise set up the pin
      } else {
        pin.removeClass('-moving -inactive -hidden')
        pin.addClass('-active')
        pinLabel.removeClass('-hidden')

        if (snap) {
          move(segment.position)
        }
      }

      // forces digest since we are working outside of angular cycles
      $scope.$applyAsync(function() {
        ctrl.selected = segment
        if (!silent) {
          ctrl.onChange({ $value: value || undefined }) // prefer undefined if null
        }
      })
    }

    function onTouchStart(e) {
      e.stopPropagation()
      e.preventDefault()

      // now we can listen for move/release
      win.on('touchmove mousemove', onTouchMove)
      win.on('touchend mouseup', onTouchEnd)

      // reset movement threshold
      ctrl.startX = ctrl.moveX = getX(e)
      ctrl.isDragging = false

      // find the closest segment
      ctrl.closest = closestSegment(ctrl.startX)
    }

    function onTouchMove(e) {
      e.stopPropagation()
      e.preventDefault()

      ctrl.moveX = getX(e)

      if (ctrl.isDragging) {
        return move(ctrl.moveX)
      }

      if (Math.abs(ctrl.startX - ctrl.moveX) > 5) {
        // pin-label should become visible and stop animating
        pinLabel.removeClass('-animate-left -hidden')
        pinLabel.addClass('-animate-visibility')

        // pin should be in a moving state
        pin.removeClass('-active -inactive -animate-left -hidden')
        pin.addClass('-moving')

        ctrl.isDragging = true
      }
    }

    function onTouchEnd(e) {
      e.stopPropagation()
      e.preventDefault()

      move(ctrl.moveX)

      // stop listening for move/release
      win.off('touchmove mousemove', onTouchMove)
      win.off('touchend mouseup', onTouchEnd)

      // if tap + same value we deselect
      if (
        !ctrl.isDragging &&
        ctrl.closest &&
        ctrl.selected &&
        ctrl.closest.value === ctrl.selected.value
      ) {
        return select(null, ctrl.snap, ctrl.snap === 'release')
      }

      // if slider was tapped, animate to position
      if (!ctrl.isDragging) {
        return select(ctrl.closest.value, ctrl.snap, true)
      }

      // if snap on release, animate to the snapped position
      select(ctrl.closest.value, !!ctrl.snap, ctrl.snap === 'release')
    }

    function move(left) {
      // find the closest segment
      ctrl.closest = closestSegment(left)

      // update the label
      pinLabel.html(ctrl.closest.label)

      // if snap enabled - snap to the position
      // otherwise let the slider float where the users finger is
      if (ctrl.snap === 'true') {
        left = ctrl.closest.position
      }

      // set the pins position
      var pinLeft = _.clamp(left, ctrl.minLeft, ctrl.maxLeft) - ctrl.minLeft // clamp between edges
      pin.css({ left: pinLeft + 'px' })

      // set the pin-label position
      var pinLabelMinLeft =
        ctrl.minLeft + pinLabel[0].offsetWidth / 2 - pin[0].offsetWidth / 2
      var pinLabelMaxLeft =
        ctrl.maxLeft - pinLabel[0].offsetWidth / 2 + pin[0].offsetWidth / 2
      var pinLabelLeft =
        _.clamp(left, pinLabelMinLeft, pinLabelMaxLeft) - ctrl.minLeft
      pinLabel.css({ left: pinLabelLeft + 'px' })
    }

    function closestSegment(position) {
      var closest = ctrl.segments[0]
      _.each(ctrl.segments, function(segment) {
        if (
          Math.abs(position - segment.position) <
          Math.abs(position - closest.position)
        ) {
          closest = segment
        }
      })
      return closest
    }

    function getSegmentWidth(isEdge) {
      if (ctrl.edgeOnly || ctrl.values.length === 2) {
        // 190 is the size of each segment on desktop mode
        // 13 is the size of component side margin
        // 16 is the size of parent component side padding
        var isMobile = 190 * 2 + 13 * 2 + 16 * 2 > document.body.offsetWidth
        return isMobile ? '50%' : '190px' // desktop mode use fixed width
      }
      var fullWidth = 100 / (ctrl.values.length - 1)
      if (isEdge) {
        return fullWidth / 2 + '%'
      }
      return fullWidth + '%'
    }

    function getLabel(value) {
      return ctrl.labelKey ? value[ctrl.labelKey] : value
    }

    function getX(event) {
      return event.touches && event.touches.length
        ? event.touches[0].pageX
        : event.pageX
    }

    function getSegmentLabel(segment, isFirst, isLast) {
      if (isFirst && ctrl.edgeOnly && ctrl.leftExtremityLabel) {
        return ctrl.leftExtremityLabel
      } else if (isLast && ctrl.edgeOnly && ctrl.rightExtremityLabel) {
        return ctrl.rightExtremityLabel
      } else {
        return segment.label
      }
    }

    function onDestroy() {
      slider.off('touchstart mousedown', onTouchStart)
      win.off('resize', layout)
    }
  }
})()
